/**
 * Декоратор класса. Записывает человекочитаемое имя сущности
 * на сам конструктор как `__title`, чтобы в рантайме можно было
 * обратиться через `Class.__title` без риска коллизии с пользовательскими полями.
 */
export default function Title_ru_RU_Class(entityTypeName: string) {
    return function <T extends { new(...args: any[]): {} }>(constructor: T) {
        (constructor as any).__entityTypeName = entityTypeName;
    };
}
